export default function() {
  return [
    {
      key: 1,
      name: this.$t('currency.newest'),
      sortName: '1',
      sortType: 'desc'
    },
    // {
    //   key: 2,
    //   name: this.$t('currency.highestInventory'),
    //   sortName: '4',
    //   sortType: 'desc'
    // },
    {
      key: 3,
      name: this.$t('currency.highestSales'),
      sortName: '3',
      sortType: 'desc'
    },
    {
      key: 4,
      name: this.$t('currency.highestPrice'),
      sortName: '2',
      sortType: 'desc'
    },
    {
      key: 5,
      name: this.$t('currency.lowestPrice'),
      sortName: '2',
      sortType: 'asc'
    }
  ]
}
